<template>
    <mu-tabs value="tab1">
        <mu-tab value="tab1" title="TAB1" />
        <mu-tab value="tab2" title="TAB2" />
        <mu-tab value="tab3" title="TAB3" />
    </mu-tabs>
</template>
<script>
export default {
    name: 'tab'
}
</script>



// WEBPACK FOOTER //
// tab.vue?339e9c72